import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { OriginalRouteService } from '../services/original-route.service';

@Injectable({
  providedIn: 'root'
})
export class NormalizeRouteGuard implements CanActivate {
  constructor(private router: Router, private originalRouteService: OriginalRouteService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const { namespecialidad } = route.params;

    const normalizedParam = this.normalizeText(namespecialidad);

    if (namespecialidad === normalizedParam) {
      return true;
    }

    this.originalRouteService.setOriginalName(namespecialidad);

    return this.router.createUrlTree(['/especialidades', normalizedParam]);
  }

  private normalizeText(text: string): string {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, ''); // Elimina tildes
  }
}
